export const invoiceIntegrationsRouteNames = {
  invoicesIntegrationsXero: 'invoices-integrations-xero',
  invoicesIntegrationsWave: 'invoices-integrations-wave',
  invoicesIntegrationsQuickbooks: 'invoices-integrations-quickbooks'
}
